import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { navigateTo } from './store/case/actions'; 
import { NavigationState } from './store/shared/types';

const NavigationListener = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Get the `destination` as a string
    const destination = useSelector((state: { navigation: NavigationState }) => state.navigation.destination);

    useEffect(() => {
        if (destination) {
            navigate(destination); // Navigate to the path

            dispatch(navigateTo('')); // Clear the destination after navigation
        }
    }, [destination, navigate, dispatch]);

    return null;
};

export default NavigationListener;
